import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})

/**
 * (REFACTOR): Whole service
 * @description: need to be handle in facade-state pattern 
 */

export class LogoService {
  logoPathType: BehaviorSubject<string> = new BehaviorSubject<any>(null);
  logoPath: BehaviorSubject<string> = new BehaviorSubject<any>(null);
  logoLoaded = false;
  private _logoPathType = 'assets/images/tart-logo-logoType.png';
  private _logoPath = 'assets/images/tart-logo.png';

  constructor(private http: HttpClient) { }

  getLogoPathType(): string {
    let logo = this.logoPathType.value;
    if(!logo) return null
    else if(logo !== this._logoPathType) {
      logo = `${environment.api}/File/Download?path=${logo}`;
    }
    if(this.logoLoaded) {
      return logo;
    }
    return null;
  }

  setLogo(logoPath: any): void {
    if(!logoPath) {
      this.logoPath.next(null); 
    }
    else if(logoPath && logoPath !== this._logoPath){
      this.logoPathType.next(logoPath);
      this.logoPath.next(logoPath);
    }
    else{
      this.setDefaultLogo();
    }
  }

  setDefaultLogo(): void {
    this.logoPathType.next(this._logoPathType);
    this.logoPath.next(this._logoPathType);
  }

  loadLogoPath(): Observable<any> {
    return this.http.get(`${environment.api}/ApplicationSetting/GetLogoPath`, { headers: { skip: 'true' } });
  }
}
